<template>
    <div class="flex flex-col w-full h-full" style="position:relative;">  
      <div class="grow-0">
        <h3>{{$t('Simulation.GridParameter')}}</h3>                             
        <div class="flex items-end gap-4">
          <div style="width:155px;height:20px" class="pb-4 !grow-0 flex justify-end shrink-0">{{ $t('Simulation.RecoveryMode') }} :</div>
          <v-select hide-details  :items="deprecoModes" item-text="libelle" item-value="value"  v-model="config.common_recovery"></v-select>
        </div>          
        <div class="flex items-end gap-4" v-if="config.common_recovery">
          <div style="width:155px;height:20px" class="pb-4 !grow-0 flex justify-end shrink-0">{{ $t('Simulation.WptRecovery') }} :</div>
          <v-select hide-details  :items="gridPointList" item-text="libelle" item-value="id"  v-model.number="config.recovery_point"></v-select>
          <!-- <v-btn class="ma-0"  icon small @click="selectRecovery()"><v-icon>mdi-map-marker-remove-variant</v-icon></v-btn> -->
        </div>  
        <div class="flex items-center gap-4">
            <div style="width:155px;height:20px" class="pb-4 !grow-0 flex justify-end shrink-0">{{ $t('Simulation.ResolutionTime') }} :</div>
            <number-field-factor persistent-hint v-model.number="modified.config.resolution_time" :hint="$t('Simulation.ResolutionTimeHint')"  :min="1" :max="120" />
        </div>            
        <h3 class="mt-2">{{$t('Simulation.GliConfig')}}</h3>   
        <v-tabs style="display:flex;flex-direction:column;" v-model="selectedGliderIdx" align-with-title >                              
            <v-tab v-for="(gliKey,idx) in gliderConfigKeys" :key="idx" >                                    
                {{ gliKey }}    
                <v-spacer />            
                <v-btn class="mr-0" small icon @click.prevent.stop="deleteGliderConfig(gliKey)" :title="$t('Pilot.MissionInfos.CloseDetailTabTooltip')">
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
            </v-tab>          
            <v-menu offset-y >
              <div slot="activator" class="cursor-pointer d-flex items-center justify-center px-3" v-ripple flat style="border-left:1px solid #eee;border-right:1px solid #eee;height:48px"><v-icon class="px-0">mdi-plus</v-icon></div>
              <v-list style="overflow: auto; max-height: 600px;">     
                <v-list-tile @click.prevent="addGliderConfig()">             
                    <v-list-tile-title><strong>{{ $t('Simulation.AddGlider') }}</strong></v-list-tile-title>            
                </v-list-tile>                            
              </v-list>  
            </v-menu>           
            <v-tab-item  v-for="(gliKey,idx) in gliderConfigKeys" :reverse-transition="false" :transition="false" :key="idx">          
              <div class="flex flex-col gap-0 pa-2">                                                
                <div  v-if="currentEditProfil">                
                  <h4>{{$t('Admin.MissionPlanTemplate.Form.NavigationProfil')}}</h4>               
                  <v-layout wrap>                                        
                  <v-flex xs4 class="inline-block pa-2">                                  
                    <number-field-factor :label="$t('Admin.MissionPlanTemplate.Form.Bd')" :hint="$t('Admin.MissionPlanTemplate.Form.BdTooltip')" v-model.number="currentEditProfil.bd" />
                    <number-field-factor :label="$t('Admin.MissionPlanTemplate.Form.Bu')" :hint="$t('Admin.MissionPlanTemplate.Form.BuTooltip')" v-model.number="currentEditProfil.bu" />
                    <number-field-factor :label="$t('Admin.MissionPlanTemplate.Form.Zs')" :hint="$t('Admin.MissionPlanTemplate.Form.ZsTooltip')" v-model.number="currentEditProfil.zs" />                
                  </v-flex> 
                  <v-flex xs4 class="inline-block pa-2">                  
                    <number-field-factor :label="$t('Admin.MissionPlanTemplate.Form.Pd')" :hint="$t('Admin.MissionPlanTemplate.Form.PdTooltip')" v-model.number="currentEditProfil.pd" />
                    <number-field-factor :label="$t('Admin.MissionPlanTemplate.Form.Pu')" :hint="$t('Admin.MissionPlanTemplate.Form.PuTooltip')" v-model.number="currentEditProfil.pu" />                                
                    <number-field-factor :label="$t('Admin.MissionPlanTemplate.Form.Zt')" :hint="$t('Admin.MissionPlanTemplate.Form.ZtTooltip')" v-model.number="currentEditProfil.zt" />                                
                  </v-flex>
                  <v-flex xs4 class="inline-block pa-2">                  
                    <number-field-factor :label="$t('Admin.MissionPlanTemplate.Form.Sr')" :hint="$t('Admin.MissionPlanTemplate.Form.SrTooltip')" v-model.number="currentEditProfil.sr" />
                    <number-field-factor :label="$t('Admin.MissionPlanTemplate.Form.Alt')" :hint="$t('Admin.MissionPlanTemplate.Form.AltTooltip')" v-model.number="currentEditProfil.alt" />   
                    <number-field-factor :label="$t('Admin.MissionPlanTemplate.Form.Zb')" :hint="$t('Admin.MissionPlanTemplate.Form.ZbTooltip')" v-model.number="currentEditProfil.zb" />                                
                  </v-flex>              
                </v-layout>
                <!-- <div class="d-flex flew-wrap items-center ">
                  <v-switch hide-details v-model="currentEditProfil.radio" :label="$t('Simulation.Radio')"></v-switch>
                  <v-switch hide-details v-model="currentEditProfil.flasher" :label="$t('Simulation.Flasher')"></v-switch>                                 
                  <v-switch hide-details v-model="currentEditProfil.current_correction" :label="$t('Simulation.CurrentCorrection')"></v-switch>   
                  <div class="d-flex items-center gap-2">
                    <span class="!grow-0">{{ $t("Simulation.NavigationMode") }}: </span>
                    <v-radio-group hide-details class="pa-0 ma-0" :column="false"  v-model="currentEditProfil.navigation_mode">                           
                      <v-radio hide-details value="heading" :label="$t('Pilot.MissionPlan.Heading')" />      
                      <v-radio hide-details value="waypoint" :label="$t('Pilot.MissionPlan.Waypoint')"  />        
                    </v-radio-group>                                             
                  </div>
                </div>         -->
              </div>
            </div>                                   
            </v-tab-item>                        
        </v-tabs>          
      </div>                
    </div>  
</template>

<script setup lang="ts">
    
  import { ref, computed, getCurrentInstance } from 'vue'  
  import store from '@/store'     
  import { i18n } from '@/locale/vueI18n'  
  import { VuetifyConfirmObject } from 'vuetify-confirm/types'
  import { getDefaultGliderCoverageConfig } from '@/models/iris/smartMission/IGliderCoverageConfig'  
  import { MissionPlanUiState } from '@/models/ui/MissionPlanUiState'
  import { AloDbFleet, AloDbFleetCoverage } from '@/models/alodb/AloDbFleet'

  // Accès aux plugins Vue via l'instance (Vue 2 + Composition API)
  const instance = getCurrentInstance()
  const $options = instance?.proxy?.$options!
  const $confirm = instance?.proxy?.$confirm!
  const $set  = instance?.proxy?.$set!

  const selectedGliderIdx = ref(-1)

  const modified = computed(() => store.myGetters.modifiedAdmAdminFleet as AloDbFleetCoverage)
  
  const param = computed(()=> modified.value.param)
  const config = computed(() => modified.value.config)
  const drawArea = ref<HTMLCanvasElement | null>(null)
  


  const deprecoModes = computed(()=>{
    return [
      {libelle:i18n.t("Simulation.Common"),value:true},
      {libelle:i18n.t("Simulation.Optimal"),value:false},
    ]
  })

  const gridPointList = computed(()=>{
    //@ts-ignore
    return modified.value.resultGridJson?.wpts?.map(w => ({libelle:`N°${w.wpt_label}  (${$options.filters[store.myGetters.coordFormatFilter]([w.wpt_lon,w.wpt_lat])})`,id:w.id})) ?? []
  })
  
   const dicPosition = computed(()=> Object.keys(modified.value.config.glider_association).reduce((dic,key) => {
                dic[modified.value.config.glider_association[key]?.at(0)?.toString() ?? key] = parseInt(key.replace('GLIDER',''))
                return dic
            },{} as Record<string,number>))

  const gliderConfigKeys = computed(() => Object.keys(modified.value.config.gliders_config).sort((a,b) => (dicPosition.value[a] ?? Number.MAX_SAFE_INTEGER) - (dicPosition.value[b] ?? Number.MAX_SAFE_INTEGER)))

  const currentEditProfil = computed(()=>{    
    const gliKey = gliderConfigKeys.value[selectedGliderIdx.value]
    if(modified.value.config?.gliders_config[gliKey] && !modified.value.config?.gliders_config[gliKey]?.prf_nav?.length){
      $set(modified.value.config.gliders_config[gliKey],"prf_nav",[{...MissionPlanUiState.getDefaultProfil(),id:1}])
    }
    return modified.value.config?.gliders_config[gliKey]?.prf_nav?.at(0)    
  })

  function addGliderConfig() {
    const nbGlider = gliderConfigKeys.value.length
    $set(modified.value.config.gliders_config,`GLIDER${nbGlider+1}`, getDefaultGliderCoverageConfig())
    selectedGliderIdx.value = nbGlider
    AloDbFleet.correctGliderAssociation(modified.value)
  }

  function deleteGliderConfig(gliKey:string) {
      $confirm(i18n.t('Admin.DeleteDialogMessage').toString(),{title: i18n.t('Admin.Warning')} as VuetifyConfirmObject).then((answer) => {
        if (answer) {     
          modified.value.config!.gliders_config = gliderConfigKeys.value.reduce((acc, key) => {
            if (key !== gliKey) {
              acc[key] = modified.value.config!.gliders_config[key]
            } 
            return acc
          }, {} as Record<string, any>)  
          AloDbFleet.correctGliderAssociation(modified.value)
        } 
      })   
  }
 

</script>